import React from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '@prisjakt/ui-app-context';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import StoreInfoList from './store-info-list';
import RecommendedRetailer from './recommended-retailer';
import StoreReviews from './store-reviews';
import PaymentProviders from '../payment-provider';

import { Award, Brand, Maybe, Price } from '../../../../../../../types';
import { Rating } from '../../../../../../../../components/rating/src/types';

import * as S from './styles';

type OwnProps = {
  brand?: Maybe<Brand>;
  brandRecommendedRetailer: boolean;
  deliveryOptions: Price['deliveryOptions'];
  priceId?: string | null;
  rating?: Rating;
  sotyBadge?: Award | null;
  store: NonNullable<Price['store']>;
  storeInfo?: (string | null)[] | null;
};

const StoreInfo = ({
  brand,
  brandRecommendedRetailer,
  deliveryOptions,
  priceId,
  rating,
  sotyBadge,
  store,
  storeInfo,
}: OwnProps) => {
  const { t } = useAppContext();

  return (
    <S.ExpandedInfo>
      <div>
        <S.StoreLink
          color="link"
          icon={<ChevronRight />}
          iconPosition="right"
          component={<Link to={store.pathName} />}
          ariaLabel={t('product', 'store-info.more-about-store', {
            store_name: store.name,
          })}
          data-test="StoreInfoLink"
        >
          <S.Title>{store.name}</S.Title>
        </S.StoreLink>

        {store.userReviewSummary.countTotal &&
        store.userReviewSummary.countTotal > 0 ? (
          <StoreReviews
            featured={Boolean(store.featured)}
            rating={rating}
            reviewCount={store.userReviewSummary.countTotal}
            storeLink={store.pathName}
          />
        ) : null}

        <StoreInfoList storeInfo={storeInfo} />

        <S.HomeDelivery deliveryOptions={deliveryOptions} />
      </div>

      {sotyBadge?.logo ? (
        <S.SotyBadge
          imgUrl={sotyBadge.logo}
          name={sotyBadge.name}
          year={sotyBadge.year?.toString()}
        />
      ) : null}

      <S.GeneralInfo>
        <S.LocationAndCurrencyInfo
          countryCode={store.countryCode}
          countryName={store.countryName}
          currency={store.currency}
          marketplace={Boolean(store.marketplace)}
          id={priceId || store.id.toString()}
          storeName={store.name}
          minify
          textSize="small"
        />

        {brandRecommendedRetailer && brand && (
          <RecommendedRetailer {...brand} />
        )}

        {store && (
          <S.PaymentProviders>
            <PaymentProviders store={store} showAll />
          </S.PaymentProviders>
        )}
      </S.GeneralInfo>
    </S.ExpandedInfo>
  );
};

export default StoreInfo;
